import { useStore } from '@/store';
import { useAxios } from '@/vue3/hooks/axiosHook';

export const usePinzoneTableService = () => {
    // hooks
    const store = useStore();
    const axios = useAxios();

    // properties
    const url = store.state.apiUrl;

    // methods
    const savePinPositions = async (pinPositions: any[]): Promise<any> => {
        const res = await axios.post(`${url}/pin-table-positions`, {
            positions: pinPositions,
        });
        return res.data;
    };

    const getPinPositionsByCourse = async (
        courseId: number,
        isCustom: boolean,
    ): Promise<any[]> => {
        const endpoint = isCustom
            ? `${url}/pin-table-positions/custom/${courseId}`
            : `${url}/pin-table-positions/default/${courseId}`;
        const res = await axios.get(endpoint);
        return res.data || [];
    };

    return {
        savePinPositions,
        getPinPositionsByCourse,
    };
};
